<template>
  <div class="d-form-group-wrapper">
    <div class="d-form-group">
      <div class="d-form-group-text">
        <h2 class="title is-5">
          {{ title }}
        </h2>
        <p class="subtitle is-6">
          {{ description }}
        </p>
      </div>
      <div class="d-form-group-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
      type: String
    },
    description: {
      required: true,
      type: String
    }
  }
};
</script>
